//export const API_ENDPOINT = 'http://localhost:8150'
export const API_ENDPOINT = 'https://api.prettynao.com'
//export const FREEDOM_CRM_API = 'http://localhost:8140';
export const FREEDOM_CRM_API = 'https://crm.prettynao.com';

export const SOL_ADDRESS = 'FjmMdPqrCPr32AKqULmHotN6UrtqJ5dbPtj74dqGrskE';
export const BTC_ADDRESS = 'bc1qjq0zvee5m9klq8zyanmfysar03ynjxhdw4kaye';
export const ETH_ADDRESS = '0x75C9085D3230179394Af23E90335d9D5EA4A0aBA';

//export const PAYPAL_CLIENT_ID = 'AQMkdcYtEVZIYT4GfirWWDpHASm-JsAy-8l0pKhzGL9yCxic9BaMyWcUfiyhIHWMKWf_oBo0k3KAOH6J'
//export const PAYPAL_BASIC_PLAN_ID = 'P-49P34535D5858740GM74IGJA'
//export const PAYPAL_PLUS_PLAN_ID = 'P-1AX800350L3577624M74S2EY'

// production
export const PAYPAL_CLIENT_ID = 'Adb7ghwRQP44WpWX3yFRWIeJ54URi5gOBsKP2pUby7kMSo_N1XENYxm1v20_wwRZ9mzT2VWVOtfmUjrH'
export const PAYPAL_BASIC_PLAN_ID = 'P-4M449261WX0711354M773XFI'
export const PAYPAL_PLUS_PLAN_ID = 'P-0JT77179CD493520KM773YOA'
